// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__QcMIv","unreadBadge":"styles_unreadBadge__33A7j","modalContent":"styles_modalContent__3ZxNE","modal":"styles_modal__1H2gw"};